import { render, staticRenderFns } from "./PdpRpaSkuStockStatus.vue?vue&type=template&id=5645fd38&"
import script from "./PdpRpaSkuStockStatus.vue?vue&type=script&lang=js&"
export * from "./PdpRpaSkuStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports